import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

import { ROUTE_PATH } from 'lib/paths'
import { useMatchList, useNavigate } from 'features/i18n/router'

import { SearchBox } from 'components'

type Props = {
  onClose?: () => void
}

export const HeaderSearch = ({ onClose }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()

  const isSearchPage = useMatchList([
    ROUTE_PATH.SEARCH_POSTS,
    ROUTE_PATH.SEARCH_USERS,
    ROUTE_PATH.SEARCH_HASHTAGS,
    ROUTE_PATH.SEARCH_GROUPS,
  ])

  const keyword = isSearchPage ? searchParams.get('keyword') ?? '' : ''

  return (
    <SearchBox
      id="search_input"
      defaultValue={keyword}
      placeholder={t('common.search_yay')}
      onSubmit={(keyword) => {
        if (isSearchPage) {
          setSearchParams((prev) => {
            if (keyword) prev.set('keyword', keyword)
            else prev.delete('keyword')

            return prev
          })
        } else {
          navigate({
            pathname: ROUTE_PATH.SEARCH_POSTS,
            search: '?keyword=' + keyword,
          })
        }

        onClose?.()
      }}
    />
  )
}
